import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { FormulaCatalogoResponse } from '../../responses/formula/formula-catalogo.response';
import { FormulaCatalogoValidacaoResponse } from '../../responses/formula/formula-catalogo-validacao.response';
import { FormulaCatalogoValidarPersonalizacoesRequest } from '../../requests/formula/formula-catalogo-validar-personalizacoes.request';

/** Acesso ao catálogo genérico de fórmulas de Suprimentos. */
@Injectable({ providedIn: 'root' })
export class FormulaCatalogoService extends CommonService {
    private readonly apiUrl = `${environment.urlApiSuprimentos}FormulaCatalogo`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getContexto(chaveRaiz = 'custo-venda'): Observable<FormulaCatalogoResponse> {
        return this.httpClient.get<FormulaCatalogoResponse>(
            `${this.apiUrl}/contextos/${encodeURIComponent(chaveRaiz)}`,
            this.addHeaderToken(),
        ).pipe(catchError(this.handleError));
    }

    public validarPersonalizacoes(request: FormulaCatalogoValidarPersonalizacoesRequest): Observable<FormulaCatalogoValidacaoResponse> {
        return this.httpClient.post<FormulaCatalogoValidacaoResponse>(
            `${this.apiUrl}/validar-personalizacoes`,
            request,
            this.addHeaderToken(),
        ).pipe(catchError(this.handleError));
    }
}
